import { DatePipe, TitleCasePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AppMainService } from "src/app/app-main.service";
import { AppMainComponent } from "src/app/app.main.component";
import { Severity, Status } from "src/app/configurations/inventory/constants/constants";
import { PurchasesService } from "src/app/inventory/purchases/purchases.service";
import { UtilsService } from "src/app/inventory/purchases/utility/utils.service";
import { SalesOrderService } from "src/app/inventory/sales-order/sales-order.service";
import { LocalDatePipe } from "src/app/shared/pipes/local-date.pipe";
import { ConfirmationService, MessageService } from "primeng/api";
import { NgxNumToWordsService, SUPPORTED_LANGUAGE } from "ngx-num-to-words";
import { FobpointService } from "src/app/configurations/inventory/setup/fobpoint/fobpoint.service";
import { CurrencyService } from "src/app/modules/shared/services/currency.service";
import { SharedChannelService } from "src/app/modules/shared/services/channel.service";
import { AccountModuleId } from "src/app/modules/shared/constants/modules.constant";
import { ChannelN } from "src/app/modules/shared/models/channel.model";
import { TypeIds } from "src/app/inventory/sales-order/constants/constants";
import * as _ from "lodash";
import { Subject, lastValueFrom, takeUntil } from "rxjs";
import { Channel, PayTo, RoutingPath, TransactionNames, typeFinanceAddEditViewText } from "src/app/finance/constants/constants";
import { FinanceService } from "src/app/finance/finance.service";
import { FinanceUtilityService } from "src/app/finance/util/finance-utility.service";
import { IBankTransaction, IBankTransactionOrderBundleProduct, IBankTransactionOrderCredit, IBankTransactionOrderExpense, IBankTransactionOrderProduct, IBankTransactionOrderVendorCredit } from "src/app/finance/models/bank-transaction.model";
import { Router } from "@angular/router";
import { ReceivePaymentDialogType } from 'src/app/modules/shared/components/receive-payments/constants/constants';
import { ImportserialService } from "../../services/importserial.service";
import { GelAllAccountRequestModel } from "src/app/accounts-v2/models/account-request.model";
import { AccountServiceN } from "src/app/accounts-v2/services/account.services";
import { AccountFlatteningService } from "src/app/inventory/sales-order/services/account-flattening.service";
import { ClosingYearDisplayMessages } from "src/app/finance/constants/closing-year.constant";
import { UtilityService } from "src/app/inventory/sales-order/utils/utility.service";
import { IPostingPeriodDetails } from "../posting-period-selector/models/posting-period.model";


@Component({
    selector: "app-write-check",
    templateUrl: "./write-check.component.html",
    styleUrls: ["./write-check.component.scss"],
    providers: [LocalDatePipe]
})
export class WriteCheckComponent implements OnInit, OnChanges, OnDestroy {
    @Input() display;
    @Input() selectedFinance;
    @Input() checkId: number;
    @Input() checkDialogType: typeFinanceAddEditViewText;
    @Input() creditMemo;
    @Input() isShowVoidDelete : boolean = true;
    @Input() isEditableViewDialog : boolean = true;
    @Output() close = new EventEmitter();
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    banks = [];
    selectedBank;
    payTo: string = PayTo.Vendor;
    isPrint: boolean = false;
    displayAddPayto = false;
    payToName: string;

    //vendor
    allVendors: any[] = [];
    allVendorsDD: any[] = [];
    selectedVendorDD;
    selectedEmployee;
    selectedVendor;
    vendorDetails;
    ordersVendorAddr = "";
    ordersVendorCity = "";
    ordersVendorState = "";
    ordersVendorCountry = "";
    ordersVendorZipcode = "";
    ordersVendorPhone = "";
    ordersVendorContact = "";
    ordersVendorAddrNew = "";
    ordersVendorCityNew = "";
    ordersVendorStateNew = "";
    ordersVendorCountryNew = "";
    ordersVendorZipcodeNew = "";
    ordersVendorPhoneNew = "";
    ordersVendorContactNew = "";
    displayVendorAddress = false;
    activeVendorAddresses: any[] = [];
    selectedVendorAddress;
    selectedVendorContact;
    displayVendorContact: boolean = false;
    orderVendorContactId: number;
    isClickVendorAddress = false;
    selectedAddress;

    //account
    accountChannels = [];
    selectedChannel;
    allAccountsDD = [];
    accountInfo;
    accountAddressInfo;
    accountAddressInfoNew;
    billingAddressContact;
    selectedAccountAddress;
    displayAccountAddress = false;
    selectedContact;
    contactSelectionModalType = "";
    displayContactSelectionModal = false;
    selectedAccountContact;
    selectedAccount;

    //expense and items
    expenseHeader;
    displayAddExpense = false;
    accountForm: FormGroup;
    expenses = [];
    items = [];
    index = 0;
    amountItem: number = 0;
    subTotal: number = 0;
    shippingAmount: number = 0;
    discount: number = 0;
    valueOptions: any[] = [];
    selectedValueOption = this.valueOptions[0];
    discountAmount: number = 0;
    amountExpense: number = 0;
    isBundle: boolean = false;
    selectedBundle;
    first: number = 0;
    pageNumber: number = 1;
    pageSize: number = 15;

    financialAccounts = [];
    productChannels = [];
    selectedTBChannel;
    totalTBRecord = 0;
    allProducts: any[] = [];
    productsData2: any[] = [];
    allProductsData2: any[] = [];
    productsTB: any[] = [];
    productsTBCol: any[] = [];
    allServiceData2: any[] = [];
    serviceData2: any[] = [];
    allNonInventoryData2: any[] = [];
    nonInventoryData2: any[] = [];
    allBundleData2: any[] = [];
    bundleData2: any[] = [];
    displayProductsTb = false;
    noCaseFindOrLoadingText = "";
    selectedProductsList: any[] = [];
    productGlobalFilterInput: string = "";
    searchValue: string = "";

    endingBalance = 0;
    writeCheckForm: FormGroup;
    locations = [];
    allFOBPoints = [];

    // product add
    displayProductSelectionModal;
    moduleName;
    headerText;
    isVisibleLocation = true;
    selectedLocation;

    numberInWords: string;
    lang: SUPPORTED_LANGUAGE = "en";
    currencySymbol = "";
    checkDetails: IBankTransaction;

    allDiscounts = [];

    /** Credit Memo */
    availableCredits = [];
    selectedCredits = [];
    totalCredit = 0;
    creditMemoDetails;
    displayCreditMemoViewDialog = false;
    // editWriteCheck: boolean = false;
    selectedLocationId: number = 0;
    selectDefaultLocation: boolean = true;

    /** Received Payment */
    displayReceivedPayment = false;
    receivedPayment = {
        receivedPaymentId: 0,
        receivePaymentDialogType: "",
    }
    isVoided: boolean = false;

    /** Vendor Credit  */
    availableVendorCredits = [];
    selectedVendorCredits = [];
    totalVendorCredit = 0;
    displayVendorCreditAddEditDialog = false;
    vendorCreditDialogHeader = "";
    selectedVendorCreditId = 0;
    vendorCreditDialogType = "VIEW";

    // fraction digits
    fractionDigits: number = 0;
    qtyFractionDigits: number = 0;
    currentPostingPeriodInfo! : IPostingPeriodDetails;
    updatedPostingPeriodInfo! : IPostingPeriodDetails;

    statementMessage: string = "";
    allUser : any[]= [];

    isAllowPostingPeriod: boolean = false;
    constructor(
        private confirmationService: ConfirmationService,
        public appMainService: AppMainService,
        public app: AppMainComponent,
        public datePipe: DatePipe,
        public localDatePipe: LocalDatePipe,
        private purchaseService: PurchasesService,
        private salesOrderService: SalesOrderService,
        private fb: FormBuilder,
        public utilService: UtilsService,
        private financeService: FinanceService,
        private messageService: MessageService,
        private titlecasePipe: TitleCasePipe,
        private ngxNumToWordsService: NgxNumToWordsService,
        private fobService: FobpointService,
        private currencyService: CurrencyService,
        private sharedChannelService: SharedChannelService,
        private financeUtilityService: FinanceUtilityService,
        private router: Router, private accountServiceN: AccountServiceN,
        private importService: ImportserialService,
        private accountFlatteningService: AccountFlatteningService,
        private utilityService: UtilityService
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.display && changes.display.currentValue) {
            this.display = changes.display.currentValue;
            this.getIsetting();
            this.initForm();
        }
        if (changes.selectedFinance && changes.selectedFinance.currentValue) {
            this.selectedFinance = changes.selectedFinance.currentValue;
            this.loadFinancialAccounts();
        }
        if (changes.checkId && changes.checkId.currentValue) {
            this.checkId = changes.checkId.currentValue;
            if (this.checkId) {
                this.getCheckDetailsById(this.checkId);
            }
        }
        if (changes.creditMemo && changes.creditMemo.currentValue) {
            this.creditMemo = changes.creditMemo.currentValue;
            this.prepareWriteCheckDataFromCreditMemo();
        }
    }
    ngOnInit(): void {
        this.getFractionDigits();
        this.getQtyDecimalDigits();
        this.getAllUsers();
        this.purchaseService
            .getVendorList()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((vendor) => {
                this.purchaseService.getAllPOVendors().subscribe((vendor) => {
                    this.allVendors = vendor;
                    this.allVendorsDD = this.allVendors?.filter((vendor) => vendor.isActive == true);
                    this.appMainService.isHideSpinner("purchase");
                });
            });
        this.getAllDiscounts();
        this.getAccountChannels(AccountModuleId);
        this.loadFOBList();

        //get discount type
        this.purchaseService
            .getAllInventoryGroups()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((res) => {
                const groupId = res.filter((r) => r?.name == "Discount Type")[0]?.id;
                this.getGroupById(groupId);
            });

        // this.initWriteCheckForm();
        // this.initAccountForm();
        this.currencySymbol = this.currencyService.currencySymbolValue;
    }
    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }
    initForm() {
        this.initWriteCheckForm();
        this.initAccountForm();
    }

    getFractionDigits() {
        this.importService
            .getDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (value) => {
                    if (value) {
                        this.fractionDigits = value;
                    }
                },
                error: (error) => { },
            });
    }
    getQtyDecimalDigits() {
        this.importService
            .getQtyDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((value) => {
                if (value) {
                    this.qtyFractionDigits = value;
                }
            });
    }
    getAllUsers(type?) {
        this.salesOrderService.getAllUser().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(resp => {
                this.allUser = resp;
                if (type == "VIEW" || type == 'EDIT') {
                    this.selectedEmployee = this.allUser?.find(x => x.id == this.checkDetails?.employeeId);
                }
            });
    }
    getAllDiscounts() {
        this.salesOrderService
            .getAllDiscount()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((res) => {
                if (res.item1) {
                    const discountsData = res.item2;
                    this.allDiscounts = discountsData.filter((d) => d?.name == "Manual");
                }
            });
    }

    loadFOBList() {
        this.fobService
            .getFOBList()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((points) => {
                if (points) {
                    this.allFOBPoints = points;
                }
            });
    }

    convertNumToWords() {
        this.numberInWords = this.ngxNumToWordsService.inWords(parseFloat(Number(this.writeCheckForm.controls.amount.value).toFixed(this.fractionDigits)), this.lang);
        this.writeCheckForm.controls.amountInWords.setValue(this.numberInWords);
    }

    initWriteCheckForm() {
        this.writeCheckForm = this.fb.group({
            id: [0],
            bankFinancialAccountId: ["", Validators.required],
            referenceNo: ["", Validators.required],
            checkDate: [this.app._showDateTimeWithZone(new Date()), Validators.required],
            amount: ["", Validators.required],
            amountInWords: ["", Validators.required],
            memo: [""],
            freight: [0],
            discountAmount: [0],
            discountType: [""],
        });
    }

    initAccountForm() {
        this.accountForm = this.fb.group({
            id: [0],
            financialAccountId: [null, [Validators.required]],
            amount: ["", [Validators.required]],
            memo: [""],
        });
    }

    onClose(type): void {
        this.accountForm.reset();
        this.writeCheckForm.reset();
        this.checkDialogType = null;
        this.close.emit({ type: type });
    }

    async getCheckDetailsById(id: number) {
        this.financeService
            .getCheckDetailsById(id)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: async (res) => {
                    this.checkDetails = res;
                    this.isVoided = res?.isVoided
                    this.setPayToValue(this.checkDetails, this.checkDialogType);
                    this.setCreditMemoData(this.checkDialogType);
                    this.setVendorCreditData(this.checkDialogType);
                    if (this.checkDetails.accountId) {
                        this.accountInfo = await this.salesOrderService.getAccountDetailsById(this.checkDetails.accountId);
                        this.selectedAccount = this.accountInfo;
                        this.selectedAccount["nameWithSequenceNumber"] = this.accountInfo?.["sequenceNumber"] + "-" + this.accountInfo?.['businessName'];
                        this.setAccountAddress(this.checkDetails.addressId)
                    }

                    this.selectedFinance = { id: this.checkDetails?.bankFinancialAccountId };
                    await this.loadFinancialAccounts();
                    this.expenses = this.checkDetails?.bankTransactionOrderExpense;
                    this.calculateExpense();

                    let groups = await lastValueFrom(this.purchaseService.getAllInventoryGroups());
                    let groupId = groups?.filter((r) => r?.name == "Discount Type")[0].id;
                    this.valueOptions = await lastValueFrom(this.purchaseService.getGroupById(groupId));
                    this.selectedValueOption = this.valueOptions?.find((v) => v.id == this.checkDetails?.discountTypeId);
                    this.isPrint = this.checkDetails?.isPrint;

                    this.writeCheckForm.patchValue({
                        ...this.checkDetails,
                        amount: parseFloat(Number(this.checkDetails.amount).toFixed(this.fractionDigits)),
                        checkDate: this.app._showDateTimeWithZone(this.checkDetails?.checkDate),
                        bankFinancialAccountId: this.financeUtilityService.findRecursiveChildObjects(this.banks, this.selectedFinance?.id)
                    });
                    this.currentPostingPeriodInfo  = {
                        postingDate: this.checkDetails?.postingDate,
                        postingMonth: this.checkDetails?.postingMonth,
                        postingYear: this.checkDetails?.postingYear
                      };
                    if (this.checkDialogType == "VIEW") {
                        this.writeCheckForm.disable();
                    }
                    else if (this.checkDialogType == 'EDIT') {
                        this.writeCheckForm.enable();
                        this.setEditExpenceTreeValue(this.expenses);
                    }
                    else {
                        this.writeCheckForm.enable();
                    }
                    this.setProductsData(this.checkDialogType);

                },
                error: (error) => {
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred...",
                    });
                },
            });
    }

    voidOrDelete(isVoid: boolean) {
        if (!!this.statementMessage) {
            this.messageService.add({ severity: Severity.Warn, summary: this.titlecasePipe.transform(Severity.Warn), detail: ClosingYearDisplayMessages.voidDeleteMessage });
        } else {
            this.confirmVoidDelete(isVoid);
        }
    }

    confirmVoidDelete(isVoid: boolean) {
        const isVoidStatus = isVoid ? 'Void' : 'Delete'
        this.confirmationService.confirm({
            message: `Do you want to ${isVoidStatus} this Write check?`,
            header: `${isVoidStatus} Confirmation`,
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.financeService.bankEntriesVoidDelete(this.checkId, isVoid, 'RemoveCheck', 'checkId').subscribe(resp => {
                    this.messageService.add({
                        severity: "success",
                        summary: "Success",
                        detail: `${isVoidStatus}${isVoid ? 'ed' : 'd'} Successfully...`,
                    });
                    this.close.emit({ type: 'edit' });
                })
            },
        });
    }

    setPayToValue(checkDetails, type: typeFinanceAddEditViewText) {
        if (checkDetails?.employeeId != 0) {
            this.payTo = PayTo.Employee;
            this.getAllUsers(type);
        }else if (checkDetails?.vendorId == 0 && checkDetails?.accountId == 0) {
            this.payTo = PayTo.Other;
        }
        else if (checkDetails?.vendorId != 0) {
            this.payTo = PayTo.Vendor;
            this.getSelectedVendorDetails(this.checkDetails?.vendorId, type);
        }
        else {
            this.payTo = PayTo.Customer;
        }
        this.payToName = this.payTo == PayTo.Other ? "Other" : this.checkDetails?.businessName;
    }
    setProductsData(type: typeFinanceAddEditViewText) {
        let products = [];
        this.checkDetails?.bankTransactionOrderProduct?.forEach((product) => {
            let data = {
                id: product?.productId || 0,
                warehouseId: product?.warehouseId || 0,
                typeId: product?.typeId || 0,
                itemNo: product?.itemNo || "",
                description: product?.description || "",
                ordQty: product?.quantity || 1,
                price: product?.pricePerProduct || 0,
                costPrice: product?.pricePerProduct || 0,
                cost: product?.totalAmount || 0,
                bankTransactionOrderProductId: product?.id || 0,
                bankTransactionId: product?.bankTransactionId || 0,
                bundleDetails: this.setBankTransactionOrderBundleProductsData(product, type),
                bankTransactionOrderProductBundleId: 0
            };
            products.push(data);
        });
        this.items = products;
        this.calculateItemExpense(type);
    }
    setCreditMemoData(type: typeFinanceAddEditViewText) {
        this.availableCredits = this.checkDetails?.bankTransactionOrderCredit?.map(element => ({
            ...element,
            number: element?.creditMemoNumber ?? "",
            status: element.creditMemoStatus ?? "",
            createdDate: this.app._showDateTimeWithZone(element.createdDate),
            createdBy: element.createdByUser ?? "",
        }));
        this.selectedCredits = this.availableCredits;
        this.totalCredit = this.availableCredits?.reduce((total, d) => total + Number(d.paidCredit), 0);
        if (this.checkDetails?.accountId && type == "EDIT") {
            const creditMemoIds = this.selectedCredits?.map(x => x.creditMemoId)?.join(",") ?? null;
            this.getCreditMemo(this.checkDetails?.accountId, type, creditMemoIds)
        }
    }
    setVendorCreditData(type: typeFinanceAddEditViewText) {
        this.availableVendorCredits = this.checkDetails?.bankTransactionOrderVendorCredit?.map(element => ({
            ...element,
            number: element?.creditMemoNumber ?? "",
            status: element?.creditMemoStatus ?? "",
            creditMemoDate: this.app._showDateTimeWithZone(element.createdDate),
            createdBy: element?.createdByUser ?? "",
            totalCreditAmount: element?.amount ?? 0,
            appliedAmount: element?.paidCredit ?? 0,
            pendingCreditAmount: element?.amount ?? 0,
        }));
        this.selectedVendorCredits = this.availableVendorCredits;
        this.totalVendorCredit = this.availableVendorCredits?.reduce((total, d) => total + Number(d.paidCredit), 0);
        if (this.checkDetails?.vendorId && type == "EDIT") {
            const vendorCreditIds = this.selectedVendorCredits?.map(x => x.vendorCreditId)?.join(",") ?? null;
            this.getVendorCredit(this.selectedVendorDD?.id, vendorCreditIds, type);
        }
    }

    /** Credit Memo to Write check */
    prepareWriteCheckDataFromCreditMemo() {
        this.payTo = PayTo.Customer;
        this.payToName = this.creditMemo?.account?.businessName ?? "";
        this.selectedAccount = this.creditMemo?.account;
        this.accountInfo = this.creditMemo?.account;
        this.setAccountAddress(this.creditMemo?.billingAddressId);
        this.writeCheckForm.patchValue({
            ...this.creditMemo,
            referenceNo: this.creditMemo.referenceNumber,
            amount: parseFloat(Number(this.creditMemo.pendingCreditAmount).toFixed(this.fractionDigits)),
            checkDate: this.app._showDateTimeWithZone(this.creditMemo?.creditMemoDate),
        });

        this.availableCredits = [
            {
                ...this.creditMemo,
                creditMemoId: this.creditMemo.id,
                status: this.creditMemo.creditMemoStatus ?? "",
                createdDate: this.app._showDateTimeWithZone(this.creditMemo.createdDate),
                createdBy: this.creditMemo.createdByUser ?? "",
                amount: this.creditMemo.pendingCreditAmount,
                paidCredit: this.creditMemo.pendingCreditAmount
            }
        ];
        this.selectedCredits = this.availableCredits;
        this.totalCredit = this.availableCredits?.reduce((total, d) => total + Number(d.paidCredit), 0);
        this.convertNumToWords();
    }
    setAccountAddress(addressId) {
        if (this.accountInfo && this.accountInfo.accountAddresses && this.accountInfo.accountAddresses.length > 0 && addressId) {
            this.accountAddressInfo = this.accountInfo.accountAddresses?.find((b) => b.addressId == addressId);
            this.selectedAccountAddress = this.accountAddressInfo;
        }
        //billing contact
        if (this.accountAddressInfo) {
            if (this.accountAddressInfo.address && this.accountAddressInfo.address.attnContactId) {
                this.billingAddressContact = this.accountAddressInfo.address.attnContact;
            } else {
                if (this.accountInfo && this.accountInfo.accountContacts) {
                    this.accountInfo.accountContacts.forEach((e) => {
                        if (e.isPrimaryContact) {
                            this.billingAddressContact = e?.contact;
                        }
                    });
                }
            }
        }
    }
    /** End Credit Memo to Write check */

    getAccountChannels(id: number) {
        this.sharedChannelService
            .getChannels(id)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res: ChannelN[]) => {
                    this.accountChannels = res;
                    this.selectedChannel = this.accountChannels.filter((ac) => ac.isDefault == true)[0];
                },
                error: (error) => {
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred...",
                    });
                },
            });
    }

    onChangeAccountChannel() {
        this.selectedAccount = null;
    }

    filterAccount(event) {
        if (!event.query.toLowerCase()) {
            this.allAccountsDD = [];
            return;
        }
        const typeId = this.selectedChannel?.id;
        this.appMainService.isShowSpinner('getAccountList');
        this.accountServiceN.getAccountsByNameWithHierarchy(typeId, event.query.toLowerCase())
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (response) => {
                    if (response) {
                        this.allAccountsDD = this.accountFlatteningService.flattenAccounts(response);;
                    }
                    this.appMainService.isHideSpinner('getAccountList');
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('getAccountList');
                },
                complete: () => {
                    this.appMainService.isHideSpinner('getAccountList');
                }
            })
    }
    initAccountInfo() {
        this.accountInfo = null;
        this.accountAddressInfo = null;
        this.billingAddressContact = null;
        this.selectedAccount = null;
    }
    //vendor
    initVendorInfo() {
        this.payToName = "";
        this.activeVendorAddresses = [];
        this.selectedVendorDD = null;
        this.ordersVendorAddr = "";
        this.ordersVendorState = "";
        this.ordersVendorCity = "";
        this.ordersVendorZipcode = "";
        this.ordersVendorCountry = "";
        this.ordersVendorContact = "";
        this.vendorDetails = null;
        this.ordersVendorPhone = null;
    }
    addPayTo() {
        this.displayAddPayto = true;
    }
    savePayto() {
        if (this.payTo == PayTo.Vendor) {
            this.payToName = this.selectedVendorDD?.name ?? "";
            this.ordersVendorAddrNew = this.ordersVendorAddr;
            this.ordersVendorCityNew = this.ordersVendorCity;
            this.ordersVendorStateNew = this.ordersVendorState;
            this.ordersVendorCountryNew = this.ordersVendorCountry;
            this.ordersVendorZipcodeNew = this.ordersVendorZipcode;
            this.ordersVendorPhoneNew = this.ordersVendorPhone;
            this.ordersVendorContactNew = this.ordersVendorContact;
            this.selectedCredits = [];
            this.selectedAccount = null;
            this.getVendorCredit(this.selectedVendorDD?.id, null, this.checkDialogType);
        } else if (this.payTo == PayTo.Employee) {
            this.payToName = this.selectedEmployee?.name ?? '';
        } else if (this.payTo == PayTo.Customer) {
            this.payToName = this.accountInfo?.businessName ?? "";
            this.accountAddressInfoNew = this.accountAddressInfo;
            this.getCreditMemo(this.accountInfo?.id, this.checkDialogType);
            this.selectedVendorCredits = [];
            this.selectedVendorDD = null;
        } else if (this.payTo == PayTo.Other) {
            this.payToName = "Other";
            this.selectedCredits = [];
            this.selectedVendorCredits = [];
            this.selectedVendorDD = null;
            this.selectedAccount = null;
        }
        this.displayAddPayto = false;
        this.calculateTotalCreditAmount();
    }
    cancelPayTo() {
        if (!this.payToName) {
            this.initAccountInfo();
            this.initVendorInfo();
        }
        this.displayAddPayto = false;
    }
    getSelectedVendorDetails(vendorId, type?) {
        this.appMainService.isShowSpinner("vendor");
        this.purchaseService
            .getVendorById(vendorId)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((value) => {
                this.vendorDetails = value;
                if (type == "VIEW" || type == 'EDIT') {
                    this.selectedVendorDD = this.allVendorsDD?.find(x => x.id == vendorId);
                }
                this.appMainService.isHideSpinner("vendor");
                this.onChangeVendor(value, type);
            });
    }
    onChangeVendor(value, type?) {
        this.isClickVendorAddress = false;
        this.activeVendorAddresses = value.vendorAddresses?.filter((add) => add.statusId == 1); //Active Address
        if (type == "VIEW") {
            this.activeVendorAddresses = value.vendorAddresses?.filter((add) => add.addressId == this.checkDetails?.addressId);
        }
        if (this.activeVendorAddresses.length == 1) {
            this.selectedAddress = this.activeVendorAddresses[0].address;
            this.ordersVendorAddr = this.activeVendorAddresses[0].address?.streetAddress1 == "" ? this.activeVendorAddresses[0].address?.streetAddress2 : this.activeVendorAddresses[0].address?.streetAddress1 + "," + this.activeVendorAddresses[0].address?.streetAddress2;
            this.ordersVendorCity = this.activeVendorAddresses[0]?.address?.city?.name ?? "";
            this.ordersVendorState = this.activeVendorAddresses[0]?.address?.state?.name ?? "";
            this.ordersVendorCountry = this.activeVendorAddresses[0]?.address?.country?.name ?? "";
            this.ordersVendorZipcode = this.activeVendorAddresses[0]?.address?.zipCode ?? "";
            if (this.activeVendorAddresses[0].address.attnContactId) {
                for (let vendorContact of value.vendorContacts) {
                    if (vendorContact.contactId == this.activeVendorAddresses[0].address.attnContactId) {
                        this.ordersVendorPhone = vendorContact.contact?.contactPhones[0]?.phone?.number;
                        this.ordersVendorContact = vendorContact.contact?.firstName + " " + vendorContact.contact?.lastName;
                    }
                }
            } else {
                for (let vendorContact of value.vendorContacts) {
                    if (vendorContact.contact?.isPrimaryContact) {
                        this.ordersVendorPhone = vendorContact.contact?.contactPhones[0]?.phone?.number;
                        this.ordersVendorContact = vendorContact.contact?.firstName + " " + vendorContact.contact?.lastName;
                    }
                }
            }
        } else if (this.activeVendorAddresses.length > 1) {
            this.selectedVendor = value;
            this.selectedVendor.vendorAddresses = value.vendorAddresses?.filter((add) => add.statusId == 1); //Active Address
            this.displayVendorAddress = type === 'show_list';
        } else {
            this.ordersVendorAddr = "";
            this.ordersVendorCity = "";
            this.ordersVendorState = "";
            this.ordersVendorCountry = "";
            this.ordersVendorZipcode = "";
            this.ordersVendorPhone = "";
            this.ordersVendorContact = "";
            for (let vendorContact of value.vendorContacts) {
                if (vendorContact.contact?.isPrimaryContact) {
                    this.ordersVendorPhone = vendorContact.contact?.contactPhones[0]?.phone?.number;
                    this.ordersVendorContact = vendorContact.contact?.firstName + " " + vendorContact.contact?.lastName;
                    this.orderVendorContactId = vendorContact.contactId;
                }
            }
        }
    }
    onRowSelectAddress(value) {
        this.displayVendorAddress = false;
        this.selectedAddress = this.selectedVendorAddress.address;
        this.ordersVendorAddr = this.selectedVendorAddress.address?.streetAddress1 == "" ? this.selectedVendorAddress.address?.streetAddress2 : this.selectedVendorAddress.address?.streetAddress1 + " " + this.selectedVendorAddress.address?.streetAddress2;
        this.ordersVendorCity = this.selectedVendorAddress?.address?.city?.name ?? "";
        this.ordersVendorState = this.selectedVendorAddress?.address?.state?.name ?? "";
        this.ordersVendorCountry = this.selectedVendorAddress?.address?.country?.name ?? "";
        this.ordersVendorZipcode = this.selectedVendorAddress.address?.zipCode;

        if (this.selectedVendorAddress.address.attnContactId) {
            for (let vendorContact of this.vendorDetails?.vendorContacts) {
                if (vendorContact.contactId == this.selectedVendorAddress.address.attnContactId) {
                    this.ordersVendorPhone = vendorContact.contact?.contactPhones[0]?.phone?.number;
                    this.ordersVendorContact = vendorContact.contact?.firstName + " " + vendorContact.contact?.lastName;
                    this.orderVendorContactId = vendorContact.contactId;
                }
            }
        } else {
            for (let vendorContact of this.vendorDetails?.vendorContacts) {
                if (vendorContact.contact?.isPrimaryContact) {
                    this.ordersVendorPhone = vendorContact.contact?.contactPhones[0]?.phone?.number;
                    this.ordersVendorContact = vendorContact.contact?.firstName + " " + vendorContact.contact?.lastName;
                    this.orderVendorContactId = vendorContact.contactId;
                }
            }
        }

        this.payToName = this.selectedVendorDD?.name ?? "";
        this.ordersVendorAddrNew = this.ordersVendorAddr;
        this.ordersVendorCityNew = this.ordersVendorCity;
        this.ordersVendorStateNew = this.ordersVendorState;
        this.ordersVendorCountryNew = this.ordersVendorCountry;
        this.ordersVendorZipcodeNew = this.ordersVendorZipcode;
        this.ordersVendorPhoneNew = this.ordersVendorPhone;
        this.ordersVendorContactNew = this.ordersVendorContact;
    }
    changeVendorContact() {
        this.selectedVendorContact = null;
        this.selectedVendorContact = this.vendorDetails?.vendorContacts?.filter((contact) => contact.contactId == this.orderVendorContactId)[0];
        this.displayVendorContact = true;
    }
    onRowSelectContactVendor() {
        this.ordersVendorPhone = this.selectedVendorContact.contact?.contactPhones[0]?.phone?.number;
        this.orderVendorContactId = this.selectedVendorContact.contactId;
        this.ordersVendorContact = this.selectedVendorContact.contact?.firstName + " " + this.selectedVendorContact.contact?.lastName;
        this.displayVendorContact = false;
    }
    //account
    async selectAccount(c) {
        this.accountInfo = null;
        this.billingAddressContact = null;
        this.accountAddressInfo = null;

        this.appMainService.isShowSpinner("loadOrderAccountsAddress");
        this.accountInfo = await this.salesOrderService.getAccountDetailsById(c.id);

        this.appMainService.isHideSpinner("loadOrderAccountsAddress");

        // default billing and shipping address
        if (this.accountInfo && this.accountInfo.accountAddresses && this.accountInfo.accountAddresses.length > 0) {
            const allBillAddress = this.accountInfo.accountAddresses.filter(
                (a) => a.address?.addressTypeId == 190, //billingAddress id
            );
            this.accountAddressInfo = allBillAddress ? allBillAddress.filter((b) => b.address?.isDefault == true)[0] : null;
            this.selectedAccountAddress = this.accountAddressInfo;
        }

        //billing contact
        if (this.accountAddressInfo) {
            if (this.accountAddressInfo.address && this.accountAddressInfo.address.attnContactId) {
                this.billingAddressContact = this.accountAddressInfo.address.attnContact;
            } else {
                if (this.accountInfo && this.accountInfo.accountContacts) {
                    this.accountInfo.accountContacts.forEach((e) => {
                        if (e.isPrimaryContact) {
                            this.billingAddressContact = e?.contact;
                        }
                    });
                }
            }
        }

        this.displayAccountAddress = this.accountInfo && this.accountInfo.accountAddresses && this.accountInfo.accountAddresses.length > 0 && !this.accountAddressInfo ? true : false;
    }
    editAccountAddress() {
        this.displayAccountAddress = true;
    }

    onRowSelectBillingAddress(e) {
        this.displayAccountAddress = false;
        this.accountAddressInfo = JSON.parse(JSON.stringify(this.selectedAccountAddress));

        if (this.accountAddressInfo && this.accountAddressInfo?.address && this.accountAddressInfo?.address?.attnContactId) {
            this.billingAddressContact = this.accountAddressInfo?.address?.attnContact;
        } else {
            if (this.accountInfo && this.accountInfo.accountContacts) {
                this.accountInfo.accountContacts.forEach((e) => {
                    if (e.isPrimaryContact) {
                        this.billingAddressContact = e?.contact;
                    }
                });
            }
        }
    }
    openContactSelectionModal(e) {
        for (let s of this.accountInfo?.accountContacts) {
            if (s.contact.id == this.billingAddressContact.id) {
                this.selectedAccountContact = s;
            }
        }
        this.contactSelectionModalType = e;
        this.displayContactSelectionModal = true;
    }
    onRowSelectContactAccount(e) {
        this.displayContactSelectionModal = false;
        this.billingAddressContact = e?.data.contact;
    }

    addExpense() {
        this.expenseHeader = "Add Expense";
        this.initAccountForm();
        this.displayAddExpense = true;
    }

    editExpense(data) {
        this.expenseHeader = "Edit Expense";
        this.initAccountForm();
        this.accountForm.patchValue({ ...data });
        this.displayAddExpense = true;
    }

    saveExpense(value) {
        if (value && value.id) {
            this.expenses?.forEach((e) => {
                if (e.id == value.id) {
                    e.financialAccountId = value.financialAccountId;
                    e.amount = value.amount;
                    e.memo = value.memo;
                }
            });
        } else {
            value["id"] = this.expenses?.length + 1;
            this.expenses.push(value);
        }
        this.calculateExpense();
        this.displayAddExpense = false;
    }

    calculateExpense() {
        this.amountExpense = 0;
        for (let exp of this.expenses) {
            this.amountExpense = this.amountExpense + exp.amount;
        }
        this.setAmountValue();
    }

    getGroupById(groupId) {
        this.purchaseService
            .getGroupById(groupId)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((res) => {
                this.valueOptions = res;
                this.selectedValueOption = this.valueOptions[0];
            });
    }

    setAmountValue() {
        let total = Number(this.amountExpense) + Number(this.amountItem) + Number(this.totalCredit) + Number(this.totalVendorCredit);
        this.writeCheckForm?.controls?.amount?.setValue(parseFloat(total.toFixed(this.fractionDigits)));
        this.convertNumToWords();
    }

    openProducts(type?, bundle?) {
        this.displayProductSelectionModal = true;
        this.selectedProductsList = this.items;
        this.moduleName = "Kit";
        this.headerText = "Add Product";
    }

    loadFinancialAccounts() {
        this.appMainService.isShowSpinner("loadaccounts");
        this.financeService
            .getAllFinancialAccounts(false)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (accounts) => {
                    let acc = JSON.parse(JSON.stringify(accounts));
                    this.financialAccounts = this.financeUtilityService.prepareFinancialAccountsData(acc);
                    this.prepareBankAccountsData(this.financialAccounts);
                    this.appMainService.isHideSpinner("loadaccounts");
                },
                error: (error) => {
                    this.appMainService.isHideSpinner("loadaccounts");
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred ...",
                    });
                },
            });
    }

    prepareBankAccountsData(accounts) {
        let selectedBank;
        let assetData = accounts?.find((a) => a?.name?.toLowerCase() == "assets");
        let bankData = assetData?.children?.filter((b) => b?.subAccountType?.name?.toLowerCase() == "bank");
        this.banks = bankData || [];
        if (this.selectedFinance?.name?.toLowerCase() == "bank" && this.selectedFinance?.id == 0) {
            selectedBank = this.banks[0];
        } else {
            selectedBank = this.financeUtilityService.findRecursiveChildObjects(this.banks, this.selectedFinance?.id);
        }

        if (selectedBank) {
            this.writeCheckForm.controls.bankFinancialAccountId.setValue(selectedBank);
            this.getEndingBalance(selectedBank?.id);
        }
    }

    getEndingBalance(id) {
        this.appMainService.isShowSpinner("loadendbalance");
        this.financeService
            .getEndingBalance(id)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (data) => {
                    this.appMainService.isHideSpinner("loadendbalance");
                    this.endingBalance = data;
                },
                error: (error) => {
                    this.appMainService.isHideSpinner("loadendbalance");
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred ...",
                    });
                },
            });
    }

    /** Vendor Credit */
    getVendorCredit(vendorId: number, vendorCreditId: any = null, type: typeFinanceAddEditViewText) {
        this.appMainService.isShowSpinner("loadvendorcredit");
        this.purchaseService
            .getVendorCreditByVendor(vendorId, vendorCreditId, 0, true, type == 'EDIT' ? this.checkDetails?.id : 0)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res) => {
                    this.availableVendorCredits = type == "EDIT" ? this.availableVendorCredits?.concat(res) : res;
                    this.appMainService.isHideSpinner("loadvendorcredit");
                },
                error: () => {
                    this.appMainService.isHideSpinner("loadvendorcredit");
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred ...",
                    });
                },
            });
    }
    calculateTotalVendorCreditAmount() {
        this.totalVendorCredit = this.selectedVendorCredits?.reduce((total, d) => total + Number(d.appliedAmount), 0);
        this.setAmountValue();
    }
    /** End Vendor Credit */

    /** Credit Memo */
    getCreditMemo(accountId: number, type: typeFinanceAddEditViewText, creditMemoId: string = null) {
        this.appMainService.isShowSpinner("loadcreditmemo");
        this.salesOrderService.getCreditMemoByAccount(accountId, creditMemoId, 0, 0, true)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: res => {
                    const data = res?.map(element => ({
                        ...element,
                        creditMemoId: element.id,
                        status: element.creditMemoStatus,
                        createdDate: this.app._showDateTimeWithZone(element.creditMemoDate),
                        createdBy: element.createdByUser,
                        amount: element.pendingCreditAmount,
                        paidCredit: element.pendingCreditAmount,
                        id: 0,
                    }));
                    if (type == "EDIT") {
                        this.availableCredits = this.availableCredits.concat(data);
                    }
                    else {
                        this.availableCredits = [];
                        this.availableCredits = data;

                    }
                    this.appMainService.isHideSpinner("loadcreditmemo");
                },
                error: () => {
                    this.appMainService.isHideSpinner("loadcreditmemo");
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred ...",
                    });
                }
            });
    }
    calculateTotalCreditAmount() {
        this.totalCredit = this.selectedCredits?.reduce((total, d) => total + Number(d.paidCredit), 0);
        this.setAmountValue();
    }
    navigateToCreditMemo(creditMemo) {
        this.display = false;
        this.router.navigate([RoutingPath.CreditMemo], {
            queryParams: {
                id: creditMemo.id,
                module: TransactionNames.CreditMemo,
                channelId: Channel.CreditMemo,
                statusId: 1,
                globalSearch: true,
                data: creditMemo.number,
            },
        });
    }

    showCreditMemoDialog(creditMemo) {
        if (creditMemo?.creditMemoId == 0 && creditMemo?.receivedPaymentId != 0) {
            this.displayReceivedPayment = true;
            this.receivedPayment.receivedPaymentId = creditMemo?.receivedPaymentId;
            this.receivedPayment.receivePaymentDialogType = ReceivePaymentDialogType.ViewPaymentDetails;
        } else {
            this.creditMemoDetails = null;
            this.displayCreditMemoViewDialog = true;
            this.appMainService.isShowSpinner("loadDetails");
            this.salesOrderService.getCreditMemoById(creditMemo.creditMemoId)
                .pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe(
                    (res) => {
                        this.appMainService.isHideSpinner("loadDetails");
                        this.creditMemoDetails = res;
                    },
                    (err) => {
                        this.appMainService.isHideSpinner("loadDetails");
                    },
                );
        }
    }
    onDialogClose() {
        this.displayCreditMemoViewDialog = false;
    }
    onReceivePaymentsDialogClose() {
        this.displayReceivedPayment = false;
        this.receivedPayment.receivedPaymentId = 0;
        this.receivedPayment.receivePaymentDialogType = "";
    }
    /** End Credit Memo */

    onChangeBankAccount(e) {
        this.getEndingBalance(e?.node?.value?.id);
    }

    /** Save Write Check */
    saveWriteCheck() {

        this.writeCheckForm.markAllAsTouched();
        this.writeCheckForm.markAsDirty();
        let isEqualBalance = Number(this.amountExpense.toFixed(this.fractionDigits)) + Number(this.amountItem.toFixed(this.fractionDigits)) + Number(this.totalCredit.toFixed(this.fractionDigits)) + Number(this.totalVendorCredit.toFixed(this.fractionDigits)) == Number(this.writeCheckForm.controls.amount.value.toFixed(this.fractionDigits));
        if (!!this.statementMessage) {
            return;
        }
        if (isEqualBalance && this.writeCheckForm?.controls?.bankFinancialAccountId?.valid) {
            let fobPoint = this.allFOBPoints?.find((fp) => fp.isDefault == true);
            let bankTransactionObj: IBankTransaction;
            //Edit
            if (this.checkDialogType == 'EDIT' && this.checkDetails?.id > 0) {
                bankTransactionObj = {
                    id: this.checkDetails.id,
                    createdSource: this.checkDetails?.createdSource ?? this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.checkDetails?.createdBy ?? this.app.user.userId,
                    updatedBy: this.app.user.userId,
                    createdDate: this.checkDetails?.createdDate ?? this.app._saveDateTimeWithZone(new Date()),
                    updatedDate: this.app._saveDateTimeWithZone(new Date()),
                    organizationId: this.checkDetails?.organizationId > 0 ? this.checkDetails?.organizationId : this.app.companyId,
                    bankFinancialAccountId: this.writeCheckForm.controls.bankFinancialAccountId?.value?.value?.id ?? 0,
                    referenceNo: this.writeCheckForm.controls.referenceNo.value,
                    checkDate: this.app._saveDateTimeWithZone(this.writeCheckForm.controls.checkDate.value),
                    amount: Number(this.writeCheckForm.controls.amount.value),
                    addressId: this.payTo == PayTo.Vendor ? this.selectedAddress?.id || 0 : this.payTo == PayTo.Customer ? this.accountAddressInfo?.address?.id || 0 : 0,
                    accountId: this.payTo == PayTo.Customer ? this.selectedAccount?.id || 0 : 0,
                    vendorId: this.payTo == PayTo.Vendor ? this.selectedVendorDD?.id || 0 : 0,
                    employeeId: this.payTo == PayTo.Employee ? this.selectedEmployee?.id || 0 : 0,
                    amountInWords: this.writeCheckForm.controls.amountInWords.value,
                    memo: this.writeCheckForm.controls.memo.value,
                    warehouseId: this.checkDetails?.warehouseId || 0,
                    channelId: this.selectedChannel?.id || 0,
                    statusId: Status.ACTIVE,
                    discountId: 0,
                    discountTypeId: this.writeCheckForm.controls.discountType?.value?.id || 0,
                    discountAmount: this.discount,
                    freight: this.writeCheckForm.controls.freight.value,
                    freightFinancialAccountId: fobPoint?.financialAccountId || 0,
                    isPrint: this.isPrint,
                    bankTransactionOrderProduct: this.prepareBankTransactionOrderProductsData(this.checkDialogType),
                    bankTransactionOrderExpense: this.prepareBankTransactionOrderExpenseData(),
                    bankTransactionOrderVendorCredit: this.payTo == PayTo.Vendor ? this.prepareBankTransactionOrderVendorCredit(this.checkDialogType) : [],
                    bankTransactionOrderCredit: this.payTo == PayTo.Customer ? this.prepareBankTransactionOrderCreditData(this.checkDialogType) : [],
                    discountFinancialId: this.allDiscounts?.filter((discount) => discount.discountBy == this.writeCheckForm?.controls?.discountType?.value?.id).map((value) => value.incomeAccount)[0],
                    postingDate: this.isAllowPostingPeriod ? this.app._saveDateTimeWithZone(this.updatedPostingPeriodInfo?.postingDate) : this.checkDetails?.postingDate,
                    postingMonth: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingMonth : this.checkDetails?.postingMonth,
                    postingYear: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingYear : this.checkDetails?.postingYear,
                };
                if (bankTransactionObj?.bankTransactionOrderExpense?.length == 0 && bankTransactionObj?.bankTransactionOrderProduct?.length == 0 && bankTransactionObj?.bankTransactionOrderCredit?.length == 0 && bankTransactionObj?.bankTransactionOrderVendorCredit?.length == 0) {
                    this.messageService.add({
                        severity: 'warn',
                        summary: this.titlecasePipe.transform('Warning'),
                        detail: "At least one Expense/Items/Credit Memo is required",
                    });
                    return;
                }
                this.appMainService.isShowSpinner("savebankentries");
                this.financeService
                    .updateBankEntries(bankTransactionObj)
                    .pipe(takeUntil(this.ngUnsubscribe$))
                    .subscribe({
                        next: (data) => {
                            this.appMainService.isHideSpinner("savebankentries");
                            this.messageService.add({
                                severity: Severity.Success,
                                summary: this.titlecasePipe.transform(Severity.Success),
                                detail: "Successfully Updated ...",
                            });
                            this.onClose("edit");
                        },
                        error: (error) => {
                            this.appMainService.isHideSpinner("savebankentries");
                            this.messageService.add({
                                severity: Severity.Error,
                                summary: this.titlecasePipe.transform(Severity.Error),
                                detail: "Error occurred while updating...",
                            });
                        },
                    });
            }
            else {
                bankTransactionObj = {
                    id: 0,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.app.user.userId,
                    updatedBy: this.app.user.userId,
                    createdDate: this.app._saveDateTimeWithZone(new Date()),
                    updatedDate: this.app._saveDateTimeWithZone(new Date()),
                    organizationId: this.app.companyId,
                    bankFinancialAccountId: this.writeCheckForm.controls.bankFinancialAccountId?.value?.value?.id ?? 0,
                    referenceNo: this.writeCheckForm.controls.referenceNo.value,
                    checkDate: this.app._saveDateTimeWithZone(this.writeCheckForm.controls.checkDate.value),
                    amount: Number(this.writeCheckForm.controls.amount.value),
                    addressId: this.payTo == PayTo.Vendor ? this.selectedAddress?.id || 0 : this.payTo == PayTo.Customer ? this.accountAddressInfo?.address?.id || 0 : 0,
                    accountId: this.selectedAccount?.id || 0,
                    vendorId: this.selectedVendorDD?.id || 0,
                    employeeId: this.payTo == PayTo.Employee ? this.selectedEmployee?.id || 0 : 0,
                    amountInWords: this.writeCheckForm.controls.amountInWords.value,
                    memo: this.writeCheckForm.controls.memo.value,
                    warehouseId: this.selectedLocation?.id || 0,
                    channelId: this.selectedChannel?.id || 0,
                    statusId: Status.ACTIVE,
                    discountId: 0,
                    discountTypeId: this.writeCheckForm.controls.discountType?.value?.id || 0,
                    discountAmount: this.discount,
                    freight: this.writeCheckForm.controls.freight.value,
                    freightFinancialAccountId: fobPoint?.financialAccountId || 0,
                    isPrint: this.isPrint,
                    bankTransactionOrderProduct: this.prepareBankTransactionOrderProductsData(this.checkDialogType),
                    bankTransactionOrderExpense: this.prepareBankTransactionOrderExpenseData(),
                    bankTransactionOrderCredit: this.payTo == PayTo.Customer ? this.prepareBankTransactionOrderCreditData(this.checkDialogType) : [],
                    bankTransactionOrderVendorCredit: this.payTo == PayTo.Vendor ? this.prepareBankTransactionOrderVendorCredit(this.checkDialogType) : [],
                    discountFinancialId: this.allDiscounts?.filter((discount) => discount.discountBy == this.writeCheckForm?.controls?.discountType?.value?.id).map((value) => value.incomeAccount)[0],
                    postingDate: this.isAllowPostingPeriod ? this.app._saveDateTimeWithZone(this.updatedPostingPeriodInfo?.postingDate) : this.app._saveDateTimeWithZone(this.writeCheckForm.controls.checkDate.value),
                    postingMonth: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingMonth : new Date(this.writeCheckForm.controls.checkDate.value).getMonth() + 1,
                    postingYear: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingYear : new Date(this.writeCheckForm.controls.checkDate.value).getFullYear()
                };
                if (bankTransactionObj?.bankTransactionOrderExpense?.length == 0 && bankTransactionObj?.bankTransactionOrderProduct?.length == 0 && bankTransactionObj?.bankTransactionOrderCredit?.length == 0 && bankTransactionObj?.bankTransactionOrderVendorCredit?.length == 0) {
                    this.messageService.add({
                        severity: 'warn',
                        summary: this.titlecasePipe.transform('Warning'),
                        detail: "At least one Expense/Items/Credit Memo is required",
                    });
                    return;
                }
                this.appMainService.isShowSpinner("savebankentries");
                this.financeService
                    .saveBankEntries(bankTransactionObj)
                    .pipe(takeUntil(this.ngUnsubscribe$))
                    .subscribe({
                        next: (data) => {
                            this.appMainService.isHideSpinner("savebankentries");
                            this.messageService.add({
                                severity: Severity.Success,
                                summary: this.titlecasePipe.transform(Severity.Success),
                                detail: "Saved Successfully ...",
                            });
                            this.onClose("save");
                        },
                        error: (error) => {
                            this.appMainService.isHideSpinner("savebankentries");
                            this.messageService.add({
                                severity: Severity.Error,
                                summary: this.titlecasePipe.transform(Severity.Error),
                                detail: "Error occurred ...",
                            });
                        },
                    });
            }

        } else {
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(Severity.Error),
                detail: "The transaction is not in balance. Make sure the amounts in the details area on the form for this transaction equal the amount at the top of the form.",
            });
        }
    }
    prepareBankTransactionOrderBundleProductsData(bProduct, type: typeFinanceAddEditViewText): IBankTransactionOrderBundleProduct[] {
        return (bProduct?.bundleDetails || []).map((item) => {
            const uomValue = item?.unit?.uomDetail?.value || 1;
            return {
                id: type == "EDIT" ? item?.bankTransactionOrderProductBundleId || 0 : 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                bankTransactionId: type == "EDIT" ? this.checkDetails?.id || 0 : 0,
                productId: bProduct?.id || 0,
                productUnitId: item?.uom?.id || 0,
                quantity: item?.ordQty || 0,
                pricePerProduct: item.costPrice,
                totalAmount: item.ordQty * item.costPrice * uomValue,
                binId: 0,
                statusId: Status.ACTIVE,
                warehouseId: type == 'EDIT' ? item?.warehouseId || 0 : this.selectedLocation?.id || 0,
                discountId: 0,
                discountTypeId: 0,
                discountAmount: 0,
                typeId: item?.typeId || 0,
                assetAccountId: 0,
                bankTransactionOrderProductId: type == "EDIT" ? item?.bankTransactionOrderProductId || 0 : 0,
                subProductId: item?.id || 0,
            };
        });
    }
    prepareBankTransactionOrderProductsData(type: typeFinanceAddEditViewText): IBankTransactionOrderProduct[] {
        return (this.items || []).map((item) => {
            const uomValue = item.unit?.uomDetail?.value || 1;
            return {
                id: type == "EDIT" ? item?.bankTransactionOrderProductId || 0 : 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                bankTransactionId: type == "EDIT" ? this.checkDetails?.id || 0 : 0,
                productId: item?.id || 0,
                productUnitId: item?.uom?.id || 0,
                quantity: item?.ordQty || 0,
                pricePerProduct: item.costPrice,
                totalAmount: item.typeId === TypeIds.BundleTypeId ? item.cost : item.ordQty * item.costPrice * uomValue,
                binId: 0,
                statusId: Status.ACTIVE,
                warehouseId: type == 'EDIT' ? item?.warehouseId || 0 : this.selectedLocation?.id || 0,
                discountId: 0,
                discountTypeId: 0,
                discountAmount: 0,
                typeId: item?.typeId || 0,
                assetAccountId: 0, // todo later
                bankTransactionOrderBundleProduct: this.prepareBankTransactionOrderBundleProductsData(item, type),
            };
        });
    }
    prepareBankTransactionOrderExpenseData(): IBankTransactionOrderExpense[] {
        return (this.expenses || []).map((expense) => ({
            id: 0,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.user.userId,
            updatedBy: this.app.user.userId,
            createdDate: this.app._saveDateTimeWithZone(new Date()),
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
            financialAccountId: expense?.financialAccountId?.value?.id || 0,
            amount: expense?.amount || 0,
            memo: expense?.memo || "",
            classId: 0, // todo later
            bankTransactionId: 0,
            statusId: Status.ACTIVE,
        }));
    }
    prepareBankTransactionOrderCreditData(type: typeFinanceAddEditViewText): IBankTransactionOrderCredit[] {
        return (this.selectedCredits || []).map((credit) => ({
            id: type == "EDIT" ? credit?.id || 0 : 0,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.user.userId,
            updatedBy: this.app.user.userId,
            createdDate: this.app._saveDateTimeWithZone(new Date()),
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
            creditMemoId: credit?.type?.toLowerCase() != "payment" ? credit?.creditMemoId ?? 0 : 0,
            receivedPaymentId: credit?.type?.toLowerCase() == "payment" ? credit?.creditMemoId ?? 0 : 0,
            accountId: this.accountInfo?.id ?? 0,
            amount: credit?.amount ?? 0,
            paidCredit: credit?.paidCredit ?? 0,
            memo: "",
            creditMemoNumber: credit?.number ?? "",
            bankTransactionId: type == "EDIT" ? this.checkDetails?.id || 0 : 0,
            statusId: Status.ACTIVE,
        }));
    }
    prepareBankTransactionOrderVendorCredit(type: typeFinanceAddEditViewText): IBankTransactionOrderVendorCredit[] {
        return (this.selectedVendorCredits || []).map((vCredit) => ({
            id: type == "EDIT" && vCredit?.vendorCreditId && vCredit?.vendorCreditId > 0 ? vCredit?.id ?? 0 : 0,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.user.userId,
            updatedBy: this.app.user.userId,
            createdDate: this.app._saveDateTimeWithZone(new Date()),
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
            vendorCreditId: type == "EDIT" && vCredit?.vendorCreditId && vCredit?.vendorCreditId > 0 ? vCredit?.vendorCreditId ?? 0 : vCredit?.id ?? 0,
            vendorId: this.selectedVendorDD?.id ?? 0,
            amount: vCredit?.totalCreditAmount ?? 0,
            memo: "",
            creditMemoNumber: vCredit?.number ?? "",
            bankTransactionId: type == "EDIT" ? this.checkDetails?.id || 0 : 0,
            statusId: Status.ACTIVE,
            paidCredit: vCredit?.appliedAmount ?? 0,
            billPaymentId: type == "EDIT" ? vCredit?.billPaymentId ?? 0 : 0,
        }));
    }
    /** End Save Write Check */

    onLocationSelect(e) {
        this.selectedLocation = e;
        this.selectedLocationId = this.selectedLocation?.id ?? 0;
    }

    onProductAddComplete(e) {
        this.items = _.cloneDeep(e);
        this.items?.forEach((e) => {
            if (e.typeId == TypeIds.BundleTypeId) {
                let bundleTotalCost = 0;
                for (let prd of e.bundleDetails) {
                    prd.ordQty = e?.ordQty * prd?.originalQty;
                    prd.cost = prd.costPrice * prd.ordQty;
                    bundleTotalCost += Number(prd.cost);
                }
                e.cost = bundleTotalCost;
            } else {
                e.cost = Number(e.costPrice) * Number(e.ordQty);
            }
        });
        this.selectedProductsList = [];
        this.calculateItemExpense();
        this.displayProductSelectionModal = false;
        // console.log(this.items);
    }

    onProductCancelClicked(e) {
        this.displayProductSelectionModal = false;
    }

    removeItem(index, type) {
        if (type == "item") {
            this.items.splice(index, 1);
            this.calculateItemExpense();
        } else {
            this.expenses.splice(index, 1);
            this.calculateExpense();
        }
    }

    calculateSubTotal(item, qty, price, bProduct?) {
        if (item.typeId != 4) {
            item.cost = price * qty;
        } else if (item.typeId == 4) {
            if (bProduct) {
                bProduct.cost = price * qty;
                let bundleTotalCost = 0;
                for (let prd of item.bundleDetails) {
                    bundleTotalCost += Number(prd.cost);
                }
                item.cost = bundleTotalCost;
            } else {
                let bundleTotalCost = 0;
                for (let prd of item.bundleDetails) {
                    prd.ordQty = item?.ordQty * prd?.originalQty;
                    prd.cost = prd.costPrice * prd.ordQty;
                    bundleTotalCost += Number(prd.cost);
                }
                item.cost = bundleTotalCost;
            }
        }
        this.calculateItemExpense();
    }

    calculateItemExpense(type?: typeFinanceAddEditViewText) {
        this.amountItem = 0;
        this.subTotal = 0;
        for (let itm of this.items) {
            this.subTotal = this.subTotal + Number(itm.cost);
        }
        if (this.subTotal == 0) {
            this.writeCheckForm.controls.freight.setValue(0);
            this.writeCheckForm.controls.discountAmount.setValue(0);
        }
        this.amountItem = this.subTotal + Number(this.writeCheckForm.controls.freight.value) - this.discount;
        this.findsum(type);
    }

    findsum(type?: typeFinanceAddEditViewText) {
        if (!this.writeCheckForm.controls.discountType.value) {
            this.writeCheckForm.controls.discountType.setValue(this.selectedValueOption);
        }

        if (this.checkDialogType == "VIEW" || type == 'EDIT') {
            if (this.selectedValueOption?.name == "Percentage") {
                let dis = this.checkDetails?.discountAmount > 0 ? (this.checkDetails?.discountAmount / this.subTotal) * 100 : 0;
                this.writeCheckForm.controls.discountAmount.setValue(dis);
            } else if (this.selectedValueOption?.name == "Amount") {
                let dis = this.checkDetails?.discountAmount;
                this.writeCheckForm.controls.discountAmount.setValue(dis);
            }
        }

        this.discount = 0;
        if (this.writeCheckForm?.controls?.discountType?.value?.name == "%" || this.writeCheckForm?.controls?.discountType?.value?.name == "Percentage") {
            this.discount = this.discount + Number(this.subTotal * (Number(this.writeCheckForm.controls.discountAmount.value) / 100));
        } else if (this.writeCheckForm?.controls?.discountType?.value?.name == "$" || this.writeCheckForm?.controls?.discountType?.value?.name == "Amount") {
            this.discount = this.writeCheckForm.controls.discountAmount.value;
        }
        this.amountItem = Number(this.subTotal + (this.subTotal > 0 ? Number(this.writeCheckForm.controls.freight.value) : 0) - this.discount);
        this.setAmountValue();
    }

    async viewToEdit(checkId: number) {
        if (checkId > 0) {
            this.checkDialogType = 'EDIT';
            await this.getCheckDetailsById(checkId);
        }
    }

    setEditExpenceTreeValue(expence: any[]) {
        expence.forEach(exp => {
            if (exp?.financialAccountId > 0) {
                let foundNode = this.financeUtilityService.findRecursiveChildObjects(this.financialAccounts, exp.financialAccountId);
                if (foundNode) {
                    exp.financialAccountId = foundNode;
                }
            }
        });
    }

    isTouched(formControlName: string): boolean {
        return this.writeCheckForm?.get(formControlName)?.touched;
    }

    hasRequiredError(formControlName: string): boolean {
        return this.writeCheckForm?.get(formControlName)?.hasError('required');
    }

    setBankTransactionOrderBundleProductsData(bProduct, type: typeFinanceAddEditViewText) {
        return (bProduct?.bankTransactionOrderBundleProduct || []).map((product) => {
            const uomValue = product?.unit?.uomDetail?.value || 1;
            return {
                id: product?.subProductId || 0,
                warehouseId: product?.warehouseId || 0,
                typeId: product?.typeId || 0,
                itemNo: product?.itemNo || "",
                description: product?.description || "",
                ordQty: product?.quantity || 1,
                price: product?.pricePerProduct || 0,
                costPrice: product?.pricePerProduct || 0,
                cost: product?.totalAmount || 0,
                bankTransactionOrderProductId: product?.bankTransactionOrderProductId || 0,
                bankTransactionId: product?.bankTransactionId || 0,
                bundleDetails: this.setBankTransactionOrderBundleProductsData(product, type),
                bankTransactionOrderProductBundleId: product?.id || 0,
                originalQty: product.originalQty
            };
        });
    }

    showVendorCreditDialog(vendorCredit) {
        this.displayVendorCreditAddEditDialog = true;
        this.vendorCreditDialogHeader = "View Vendor Credit";
        this.selectedVendorCreditId = this.checkDialogType == 'EDIT' || this.checkDialogType == 'VIEW' ? vendorCredit?.vendorCreditId : vendorCredit?.id;
    }
    onCloseVendorCreditDialog(e) {
        this.displayVendorCreditAddEditDialog = false;
    }

    isClosingStatementDate(event: string) {
        this.statementMessage = event;
    }

    onPostingInfoChange(postingInfo: IPostingPeriodDetails) {
        this.updatedPostingPeriodInfo = postingInfo;
      }

    getIsetting() {
        this.appMainService.isShowSpinner("loadISettings");
        const iSettings = this.utilityService.getISettings();
        this.isAllowPostingPeriod = iSettings?.find(obj => obj.code === 'posting')?.enabled ?? false;
        this.appMainService.isHideSpinner("loadISettings");
    }
}
